import React from 'react';
import { InputNumber, Typography } from 'antd';

const { Text } = Typography;

interface PillNumberFieldProps {
  label: string;
  min?: number;
  step?: number;
  addonAfter?: string;
  disabled?: boolean;
  value?: number;
  onChange?: (value: number | null) => void;
}

/**
 * Small fixed label + pill input, for numeric fields outside the publish
 * wizard (see HeavyDutyMachineryForm's own local copy of this, kept separate on
 * purpose so this one can evolve independently of that page). A plain
 * caption above never overlaps the value regardless of label length, unlike
 * a floating label. Also covers currency fields specifically because
 * addonAfter nests the real .ant-input-number in its own extra group
 * wrapper that the floating CSS never targeted either way.
 */
const PillNumberField: React.FC<PillNumberFieldProps> = ({ label, value, onChange, addonAfter, ...rest }) => (
  <div>
    <Text type="secondary" style={{ display: 'block', fontSize: 12, marginBottom: 6 }}>
      {label}
    </Text>
    <InputNumber
      {...rest}
      addonAfter={addonAfter}
      className={addonAfter ? 'wizard-currency-input' : 'wizard-number-input'}
      style={{ width: '100%' }}
      value={value}
      onChange={onChange}
      // Same fix as HeavyDutyMachineryForm's local copy: without this, iOS shows
      // its default letters keyboard for what's a plain text input under
      // the hood, so typed letters don't parse as a number (silently
      // becoming null) but nothing stops you typing them in the first
      // place. The numeric keypad this brings up has no letter keys at all.
      inputMode="decimal"
    />
  </div>
);

export default PillNumberField;
